import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  private _isFullLoading: boolean = true;
  private _isFullLoading$ = new BehaviorSubject<boolean>(this._isFullLoading);

  private _isLoading: boolean = true;
  public isLoading$ = new BehaviorSubject<boolean>(this._isLoading);

  private _isDev: boolean = false;

  private _dragDropFile: File | undefined;
  public dragDropFile$: BehaviorSubject<File | undefined> = new BehaviorSubject<File | undefined>(
    undefined,
  );

  public deviceMode: 'horizontal' | 'vertical' = 'vertical';

  public isSideBarVisible: boolean = false;
  public isBottomBarVisible: boolean = false;
  public isBottomEditerBarVisible: boolean = false;

  private selectedToolType: string = '';

  constructor() {}

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  get isFullLoading(): boolean {
    return this._isFullLoading;
  }

  set isFullLoading(value: boolean) {
    this._isFullLoading = value;
    this._isFullLoading$.next(value);
  }

  get isFullLoading$(): BehaviorSubject<boolean> {
    return this._isFullLoading$;
  }

  get isLoading(): boolean {
    return this._isLoading;
  }

  set isLoading(value: boolean) {
    this._isLoading = value;
    this.isLoading$.next(value);
  }

  get isDev(): boolean {
    return this._isDev;
  }

  set isDev(value: boolean) {
    this._isDev = value;
  }

  get dragDropFile(): File | undefined {
    return this._dragDropFile;
  }

  set dragDropFile(value: File | undefined) {
    this._dragDropFile = value;
    this.dragDropFile$.next(value);
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  public getMainDomWidth(): string {
    let size: string = '100%';
    if (this.isSideBarVisible) size = this.deviceMode == 'vertical' ? '100%' : '75%';
    return size;
  }

  public getMainDomHeight(): string {
    let size: string = '100%';
    if (this.isSideBarVisible) size = this.deviceMode == 'vertical' ? '50%' : '100%';
    return size;
  }

  public getThreeRenderWidth(): string {
    let size: string = '100%';
    return size;
  }

  public getThreeRenderHeight(): string {
    let size: string = '100%';
    if (this.isBottomBarVisible) size = this.deviceMode == 'vertical' ? '90%' : '85%';
    if (this.isBottomBarVisible && this.isBottomEditerBarVisible)
      size = this.deviceMode == 'vertical' ? '50%' : '65%';
    return size;
  }

  public getBottomBarHeight(): string {
    let size: string = '0%';
    if (this.isBottomBarVisible) size = this.deviceMode == 'vertical' ? '10%' : '15%';
    return size;
  }

  public getBottomEditerBarHeight(): string {
    let size: string = '0%';
    if (this.isBottomEditerBarVisible) size = this.deviceMode == 'vertical' ? '40%' : '20%';
    return size;
  }

  public getSideBarWidth(): string {
    let size: string = '0%';
    if (this.isSideBarVisible) size = this.deviceMode == 'vertical' ? '100%' : '25%';
    return size;
  }

  public getSideBarHeight(): string {
    let size: string = '100%';
    if (this.isSideBarVisible) size = this.deviceMode == 'vertical' ? '50%' : '100%';
    else size = this.deviceMode == 'vertical' ? '0%' : '100%';
    return size;
  }

  public setDisplaySettimgByToolType(toolType: string): void {
    if (this.selectedToolType == toolType || toolType == '') {
      this.isBottomBarVisible = false;
      this.isBottomEditerBarVisible = false;
      this.isSideBarVisible = false;
    } else if (toolType == 'Part') {
      this.isBottomBarVisible = true;
      this.isBottomEditerBarVisible = false;
      this.isSideBarVisible = false;
    } else if (
      toolType == 'Wrap' ||
      toolType == 'Livery' ||
      toolType == 'AI agent' ||
      toolType == 'Preset'
    ) {
      this.isBottomBarVisible = false;
      this.isBottomEditerBarVisible = false;
      this.isSideBarVisible = true;
    }

    this.selectedToolType = this.selectedToolType == toolType ? '' : toolType;
  }
}
